<template>
  <b-sidebar
      v-model="visible"
      id="userdietorderdetails"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          جزئیات سفارش
        </h5>

        <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
        />

      </div>

      <b-form
          class="p-2"
          @submit.prevent
      >

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            محصول:
          </label>
          <p style="font-weight: 600;">
            {{ obj.DietDurationPrice.Diet.Title }} {{ obj.DietDurationPrice.DietDuration.Title }}
          </p>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            تخفیف:
          </label>
          <p style="font-weight: 600;">
            {{ obj.Coupon ? obj.Coupon.Title : '-' }}
          </p>
        </div>

        <hr style="margin-top: 0px;">

        <div style="display: flex; justify-content: space-between; margin-top: 2rem;">
          <label style="font-weight: 600;">
            مبلغ:
          </label>
          <p style="font-weight: 600;" class="text-primary">
            {{ obj.Price | price }}
          </p>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            تاریخ:
          </label>
          <p style="font-weight: 600;">
            {{ obj.CreatedAt | date }}
          </p>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            ساعت:
          </label>
          <p style="font-weight: 600;">
            {{ obj.CreatedAt | time}}
          </p>
        </div>

        <div style="display: flex; justify-content: space-between;">
                      <label style="font-weight: 600;">
                        کد پیگیری:
                      </label>
                      <p style="font-weight: 600;"  class="text-warning">
                        {{ obj.Code }}
                      </p>
                    </div>

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            شماره کارت:
          </label>
          <p style="font-weight: 600;">
            {{ obj.CardNumber }}
          </p>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <label style="font-weight: 600;">
            توضیحات:
          </label>
          <p style="font-weight: 600; text-align: justify; padding-right: 1rem;">
            {{ obj.Description ? obj.Description : '-' }}
          </p>
        </div>

        <hr>

        <div class="d-flex mt-2" style="align-items: flex-end; margin-top: 2rem;" v-if="obj.Status === 0">

          <b-form-group style="margin-bottom: 0px; width: 100%;" label-for="Status" label="وضعیت:">
            <v-select
                v-model="status"
                :options="enums('Status')"
                dir="rtl"
                id="Status"
                label="text"
                :reduce="x => x.value"
                :clearable="false"
            />
          </b-form-group>

          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              @click="save"
              style="margin-right: 1rem; margin-left: 0 !important;"
              :disabled="status === 0"
          >
            ذخیره
          </b-button>

        </div>
        <div v-else style="display: flex; justify-content: space-between; margin-top: 2rem;">
          <label style="font-weight: 600;">
            وضعیت:
          </label>
          <p :class="'text-'+ enums('Status', 'value', obj.Status, 'badge')" style="font-weight: 600; text-align: justify; padding-right: 1rem;">
            {{ enums('Status', 'value', obj.Status, 'text') }}
          </p>
        </div>

      </b-form>
    </template>
  </b-sidebar>
</template>

<script>

import { BSidebar } from 'bootstrap-vue'

export default {
  name: 'UserDietOrderDetails',
  components: {
    BSidebar,
  },
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: true,
      status: this.obj.Status
    }
  },
  watch: {
    visible(v) {
      if (v === false){
        this.$emit('close')
      }
    },
  },
  methods: {
    save() {
      this.Report = null
      this.$http.post(
           this.$api.userdietorder.changestatus, {Id: this.obj.Id, Status: this.status },
      )
          .then(res => {
             this.obj.Status = this.status
            this.isVisible = false
          })
          .finally(() => {
            this.loading = false
          })
    },
  },
}
</script>

<style scoped>

</style>